import { useEffect, useState } from "react";
import { Loader2, Printer, HeartHandshake } from "lucide-react";
import { api } from "../../lib/api";

const money = (v) => `$${Number(v || 0).toFixed(2)}`;

export const GivingSection = () => {
  const [data, setData] = useState(null);
  const [year, setYear] = useState("");
  const [err, setErr] = useState("");

  const load = (y) => {
    setData(null);
    api.get("/members/giving", { params: y ? { year: y } : {} })
      .then((r) => setData(r.data))
      .catch((e) => setErr(e?.response?.data?.detail || "Unable to load giving history"));
  };
  useEffect(() => { load(""); }, []);

  if (err) return <p className="text-black/50 py-10 text-center">{err}</p>;
  if (!data) return <div className="py-16 grid place-items-center"><Loader2 className="animate-spin text-[#E63946]" /></div>;

  return (
    <div data-testid="giving-section">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-5">
        <div className="flex gap-2 items-center">
          <select value={year} onChange={(e) => { setYear(e.target.value); load(e.target.value); }} data-testid="giving-year-select"
            className="border border-black/15 rounded-full px-4 py-2 text-sm outline-none focus:border-[#E63946]">
            <option value="">All Time</option>
            {data.years.map((y) => <option key={y} value={y}>{y}</option>)}
          </select>
        </div>
        <button onClick={() => window.print()} className="inline-flex items-center gap-2 rounded-full border border-black/15 px-4 py-2 text-sm hover:bg-black/5"><Printer size={14} /> Print Statement</button>
      </div>
      <div className="grid sm:grid-cols-3 gap-3 mb-6">
        <div className="bg-white border border-black/10 rounded-xl p-4"><p className="text-xs uppercase tracking-wider text-black/40">Total {year || "Giving"}</p><p className="font-display font-bold text-2xl text-[#E63946]" data-testid="giving-total">{money(data.total)}</p></div>
        <div className="bg-white border border-black/10 rounded-xl p-4"><p className="text-xs uppercase tracking-wider text-black/40">This Year</p><p className="font-display font-bold text-2xl">{money(data.ytd)}</p></div>
        <div className="bg-white border border-black/10 rounded-xl p-4"><p className="text-xs uppercase tracking-wider text-black/40">Lifetime</p><p className="font-display font-bold text-2xl">{money(data.lifetime)}</p></div>
      </div>
      {Object.keys(data.by_fund).length > 0 && (
        <div className="bg-white border border-black/10 rounded-xl p-5 mb-6">
          <p className="text-xs uppercase tracking-wider text-black/40 mb-3">By Fund</p>
          {Object.entries(data.by_fund).map(([f, v]) => (
            <div key={f} className="flex justify-between text-sm py-1"><span>{f}</span><span className="font-medium">{money(v)}</span></div>
          ))}
        </div>
      )}
      <div className="space-y-2">
        {data.gifts.map((g, i) => (
          <div key={`${g.date}-${g.ref}-${i}`} className="flex items-center gap-4 bg-white border border-black/10 rounded-xl p-4" data-testid="gift-row">
            <HeartHandshake size={18} className="text-[#E63946] shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="font-medium text-sm">{g.fund}{g.recurring ? " · Recurring" : ""}</p>
              <p className="text-xs text-black/45">{g.date ? new Date(g.date).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }) : ""} · {g.method} · Ref …{g.ref}</p>
            </div>
            <span className="font-display font-bold">{money(g.amount)}</span>
          </div>
        ))}
        {data.gifts.length === 0 && <p className="text-black/40 py-12 text-center">No giving records found for this email yet. Gifts made with {""}your verified email will appear here automatically.</p>}
      </div>
      <p className="text-xs text-black/40 mt-5">Giving is tracked separately from store purchases and event tickets — merchandise never counts toward your giving total.</p>
    </div>
  );
};
